var map = {
	"./": [
		53092,
		7,
		92
	],
	"./index": [
		53092,
		7,
		92
	],
	"./index-1c5c47b4": [
		49818,
		9
	],
	"./index-1c5c47b4.js": [
		49818,
		9
	],
	"./index.js": [
		53092,
		7,
		92
	],
	"./ionicpwaelements": [
		25849,
		9,
		849
	],
	"./ionicpwaelements.js": [
		25849,
		9,
		849
	],
	"./loader": [
		45929,
		9
	],
	"./loader.js": [
		45929,
		9
	],
	"./pwa-action-sheet.entry": [
		49875,
		9,
		875
	],
	"./pwa-action-sheet.entry.js": [
		49875,
		9,
		875
	],
	"./pwa-camera-modal-instance.entry": [
		75950,
		9,
		569
	],
	"./pwa-camera-modal-instance.entry.js": [
		75950,
		9,
		569
	],
	"./pwa-camera-modal.entry": [
		33616,
		9,
		616
	],
	"./pwa-camera-modal.entry.js": [
		33616,
		9,
		616
	],
	"./pwa-camera.entry": [
		3604,
		9,
		604
	],
	"./pwa-camera.entry.js": [
		3604,
		9,
		604
	],
	"./pwa-toast.entry": [
		68320,
		9,
		320
	],
	"./pwa-toast.entry.js": [
		68320,
		9,
		320
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 37179;
module.exports = webpackAsyncContext;